// Dados do site — O.C. GOMES SISTEMA DE INJEÇÃO DIESEL

export const companyInfo = {
  name: "O.C. GOMES",
  fullName: "O.C. GOMES SISTEMA DE INJEÇÃO DIESEL",
  legalName: "O.C. Gomes Sistema de Injeção Diesel LTDA",
  cnpj: "42.691.118/0001-53",
  tagline: "Injeção eletrônica, mecânica e unidades injetoras, com teste em bancada própria.",
  phone: "(21) 96497-5584",
  email: "ocgdiesel@outlook.com",
  address: "Av. Jornalista Roberto Marinho, 197 – Colubandê – São Gonçalo – RJ – CEP 24451-045",
  hours: "Segunda a sexta, das 8h às 18h",
  warranty: "90 dias de garantia",
  mapsUrl: "https://www.google.com/maps/place/O.C.+GOMES+SISTEMA+DE+INJE%C3%87%C3%83O+DIESEL+LTDA/@-22.8284085,-43.0256806,17z/data=!3m1!4b1!4m6!3m5!1s0x999a913bd38bdd:0x44a9f40e7c048ecd!8m2!3d-22.8284085!4d-43.0231057!16s%2Fg%2F1tjyvv39",
  mapsEmbedUrl: "https://www.google.com/maps?q=-22.8284085,-43.0231057&z=17&output=embed",
  socials: [
    { label: "Instagram", url: "https://www.instagram.com/ocgdiesel/" }
  ]
};

export const phoneDigits = companyInfo.phone.replace(/\D/g, '');

export const whatsappLink = (message = "Olá! Gostaria de um orçamento para o meu sistema de injeção diesel.") =>
  `https://wa.me/55${phoneDigits}?text=${encodeURIComponent(message)}`;

export const trustItems = [
  { icon: "Award", text: "+15 anos de experiência" },
  { icon: "Gauge", text: "Bancadas próprias de teste" },
  { icon: "ShieldCheck", text: "90 dias de garantia nos serviços" },
  { icon: "Truck", text: "Atendemos todas as marcas diesel" }
];

export const services = [
  {
    id: 1,
    title: "Injeção Eletrônica",
    description: "Diagnóstico e reparo de sistemas de injeção eletrônica diesel com teste em bancada Devoc Corvus.",
    icon: "Cpu",
    features: [
      "Diagnóstico computadorizado",
      "Teste em bancada eletrônica",
      "Reparo de injetores e bombas de alta pressão Common Rail",
      "90 dias de garantia"
    ],
    whatsapp: "Olá! Gostaria de um orçamento para Injeção Eletrônica."
  },
  {
    id: 2,
    title: "Injeção Mecânica",
    description: "Recondicionamento e calibração de bombas injetoras mecânicas e bicos injetores, com regulagem de precisão.",
    icon: "Settings",
    features: [
      "Recondicionamento de bombas",
      "Calibração em bancada de até 12 cilindros",
      "Bombas VE, CAV e Stanadyne",
      "90 dias de garantia"
    ],
    whatsapp: "Olá! Gostaria de um orçamento para Injeção Mecânica."
  },
  {
    id: 3,
    title: "Unidades Injetoras",
    description: "Teste e reparo de unidades injetoras EUI/EUP e HEUI (Scania, Volvo, Caterpillar, Mercedes-Benz).",
    icon: "Wrench",
    features: [
      "Teste em bancada Devoc Corvus",
      "Unidades EUI/EUP e HEUI",
      "Substituição de componentes",
      "90 dias de garantia"
    ],
    whatsapp: "Olá! Gostaria de um orçamento para Unidades Injetoras."
  }
];

export const steps = [
  { icon: "MessageCircle", title: "Envie o problema pelo WhatsApp", text: "Descreva o defeito e informe veículo, modelo e ano." },
  { icon: "Gauge", title: "Diagnóstico em bancada", text: "Testamos a peça nas nossas bancadas para identificar a causa." },
  { icon: "FileCheck", title: "Orçamento aprovado", text: "Você recebe o orçamento antes de qualquer reparo, sem compromisso." },
  { icon: "ShieldCheck", title: "Reparo e teste", text: "Reparo, teste final em bancada e 90 dias de garantia." }
];

export const vehicleTypes = [
  { icon: "Truck", title: "Caminhões", text: "Leves, médios e pesados" },
  { icon: "Bus", title: "Ônibus", text: "Urbanos, rodoviários e fretamento" },
  { icon: "Car", title: "Picapes e SUVs", text: "Diesel de passeio e trabalho" },
  { icon: "Tractor", title: "Máquinas agrícolas e pesadas", text: "Tratores, colheitadeiras e equipamentos" },
  { icon: "Building2", title: "Frotas", text: "Atendimento para empresas e transportadoras" }
];

export const brands = ["Cummins", "Scania", "Volvo", "Mercedes-Benz", "Caterpillar"];

export const aboutFacts = [
  "Mais de 15 anos de experiência em sistemas de injeção diesel",
  "Bancada eletrônica Devoc Corvus para Common Rail, EUI/EUP e HEUI",
  "Bancada Neumann NEV 7.5 PT para bombas Cummins NTA",
  "Bancada para bombas mecânicas de até 12 cilindros (VE, CAV, Stanadyne)",
  "Diagnóstico em bancada e orçamento antes de qualquer reparo",
  "90 dias de garantia em todos os serviços"
];

export const reviews = [
  {
    name: "Robson Sant' Ana Garcia",
    badge: "Local Guide",
    stars: 5,
    text: "Atendimento, ambiente, profissionalismo, explica todo problema e como deve ser solucionado. Todos os comentários elogiáveis são verdadeiros. Valeu a pena."
  },
  { name: "Hugo César", badge: "Local Guide", stars: 5, text: "Excelentes profissionais!" },
  {
    name: "Katia Rosana",
    badge: null,
    stars: 5,
    text: "Excelente!!! Ótimo atendimento, desde o primeiro contato pelo ZAP com a Juliana. O mecânico muito competente. Gratidão."
  }
];

export const faqs = [
  { q: "Qual a garantia dos serviços?", a: "Todos os serviços têm 90 dias de garantia. Se tiver qualquer problema nesse período, é só entrar em contato." },
  { q: "Fazem orçamento antes do serviço?", a: "Sim. Fazemos o diagnóstico em bancada e passamos o orçamento antes de qualquer reparo, sem compromisso." },
  { q: "Como envio a peça para análise?", a: "Chame no WhatsApp, descreva o problema e informe o veículo, modelo e ano. Depois é só trazer a peça até a oficina em Colubandê – São Gonçalo." },
  { q: "Vocês atendem frotas?", a: "Sim, atendemos todas as marcas de veículos movidos a diesel, incluindo caminhões, ônibus, máquinas e frotas." },
  { q: "Qual o horário de atendimento?", a: "De segunda a sexta, das 8h às 18h." }
];

export const benches = [
  {
    id: 1,
    name: "Devoc Corvus",
    brand: "Bancada de Teste Eletrônica",
    images: ["/bench-corvus-1.jpg", "/bench-corvus-2.jpg", "/bench-corvus-3.jpg"],
    description: "Calibra e testa todo o sistema Common Rail, tanto bombas de alta pressão quanto bicos injetores. Realiza também o teste de unidades injetoras HEUI (Caterpillar C7 e C9) e de unidades EUI/EUP das principais marcas do mercado.",
    tests: [
      "Bicos Injetores Common Rail",
      "Bombas de Alta Pressão Common Rail",
      "Unidades Injetoras HEUI (Caterpillar C7 e C9)",
      "Unidades EUI/EUP Scania e Volvo",
      "Unidades EUI/EUP Caterpillar",
      "Unidades EUI/EUP Mercedes-Benz"
    ]
  },
  {
    id: 2,
    name: "Neumann NEV 7.5 PT",
    brand: "Bancada para Bombas Cummins",
    images: ["/bench-neumann-pt.jpg"],
    description: "Bancada dedicada à calibração e teste de bombas de motores Cummins NTA (sistema PT), garantindo regulagem precisa conforme a especificação do fabricante.",
    tests: [
      "Bombas de Motores Cummins NTA",
      "Calibração do Sistema PT",
      "Regulagem de Pressão e Vazão",
      "Teste de Desempenho da Bomba"
    ]
  },
  {
    id: 3,
    name: "Bancada de Bombas Injetoras Mecânicas",
    brand: "Bancada de Teste Mecânica",
    images: ["/bench-bombas-mecanicas.jpg"],
    description: "Calibra bombas injetoras mecânicas de até 12 cilindros, incluindo bombas rotativas VE, CAV e Stanadyne, com medição precisa de débito e regulagem conforme a especificação de cada modelo.",
    tests: [
      "Bombas em Linha de até 12 Cilindros",
      "Bombas Rotativas VE",
      "Bombas CAV",
      "Bombas Stanadyne"
    ]
  }
];

export const images = {
  hero: "/hero-injectors.png",
  about: "/about-diagnostic.png"
};
